const appConfig = {
    apiURL: process.env.REACT_APP_API_URL
};

export { appConfig };
